import React from 'react';

export default function arrowRight(props: {
  className?: string;
  onClick?: () => void;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      onClick={props.onClick}
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
    >
      <path
        d="M15 9.5L9.53674e-07 0.839746V18.1603L15 9.5ZM0 11H1.5V8H0L0 11Z"
        fill="#6C757D"
      />
    </svg>
  );
}
